import { mapping } from "#vuepal-build/route-queries";
import {
  useAsyncGraphqlQuery,
  useRoute,
  useDrupalRoute,
  createError
} from "#imports";
export async function useDrupalRouteQuery(name, options) {
  const noError = !!options?.noError;
  const route = useRoute();
  const queryName = mapping[name];
  const { data, error } = await useAsyncGraphqlQuery(
    queryName,
    {
      path: route.path
    },
    {
      transform: function(data2) {
        return data2.data;
      },
      graphqlCaching: {
        client: options?.clientCache ?? true
      },
      deep: false
    }
  );
  if (error.value && !noError) {
    throw createError({
      statusCode: 500,
      statusMessage: error.value.message,
      fatal: true
    });
  }
  const ctx = await useDrupalRoute(
    data.value,
    {
      // @ts-expect-error issue with overload, boolean is correct.
      noError
    },
    route
  );
  if (!noError && data.value && "route" in data.value && data.value.route && data.value.route.__typename && !["EntityCanonicalUrl", "DefaultEntityUrl"].includes(
    data.value.route?.__typename
  )) {
    throw createError({
      statusCode: 404,
      statusMessage: "Page not found",
      fatal: true
    });
  }
  return ctx;
}
